export function formatDate(date: Date | string) {
  const dateObj = date instanceof Date ? date : new Date(date);

  // use browser date formatting using user locale
  return dateObj.toLocaleDateString();
}
